/**
 * LocalStorage helper utilities
 */

export interface PanelPosition {
    x: number;
    y: number;
}

const KEYS = {
    LAST_SEARCHED_BIB: 'lastSearchedBib',
    PANEL_POSITION: 'athlete-panel-position'
};

/**
 * Gets the last searched bib number from localStorage
 */
export function getLastSearchedBib(): string | null {
    return localStorage.getItem(KEYS.LAST_SEARCHED_BIB);
}

/**
 * Saves the last searched bib number to localStorage
 */
export function saveLastSearchedBib(bib: string): void {
    localStorage.setItem(KEYS.LAST_SEARCHED_BIB, bib);
}

/**
 * Gets the saved panel position from localStorage
 */
export function getPanelPosition(): PanelPosition | null {
    const saved = localStorage.getItem(KEYS.PANEL_POSITION);
    if (saved) {
        try {
            return JSON.parse(saved);
        } catch {
            return null;
        }
    }
    return null;
}

/**
 * Saves the panel position to localStorage
 */
export function savePanelPosition(position: PanelPosition): void {
    localStorage.setItem(KEYS.PANEL_POSITION, JSON.stringify(position));
}
